var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "raft-js-bio-data-window-wrapper"
  }, [_c('BIconSearch', {
    attrs: {
      "alt": "Show Material Data",
      "data-test": "show-material",
      "id": _vm.iconSearchId
    },
    on: {
      "click": _vm.loadEntity
    }
  }), _vm._v(" "), _c('b-popover', {
    attrs: {
      "target": _vm.iconSearchId,
      "data-test": "outside-vif",
      "id": _vm.popoverId,
      "placement": "right",
      "triggers": "click blur"
    }
  }, [_vm.isLoading ? _c('raft-busy', {
    attrs: {
      "busy-text": "Loading..."
    }
  }) : _vm.bioMaterial ? [_vm.materialId ? _c('BioMaterialRender', {
    attrs: {
      "bio-material": _vm.bioMaterial,
      "display-field-data": _vm.displayData,
      "data-test": "inside-vif",
      "material-type-label": _vm.materialTypeLabel
    }
  }) : _vm._e()] : [_c('ErrorStateLinks')]], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }